import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

export const permissionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const userData = authService.getUserData();

  const requiredPermission = route.data.permission;

  if (requiredPermission) {
    const userPermissions = userData.userProfile.permissions.map((permission) => permission.userFunction.name);
    if (!userPermissions.includes(requiredPermission)) {
      return router.createUrlTree(['/error/unauthorized']);
    }
  }

  return true;
};
